import React from "react";
import Select from "../helper/Select";
import { Controller } from "react-hook-form";
import handleErrorMsg from "../helper/handleErrorMsg";
import useTranslation from "next-translate/useTranslation";

const defaultGetOptionValue = (option) => option.value;

export default function SelectController({
  name,
  control,
  rules,
  defaultValue = "",
  inputProps,
  onSubmit,
  searchIndicator,
  handleTitle,
  ...otherProps
}) {
  const { t } = useTranslation("common-locale");
  const getOptionValue = otherProps.getOptionValue || defaultGetOptionValue;

  const returnValue = (val) => {
    const singleOption = otherProps?.options?.filter(
      (option) => getOptionValue(option) === val
    );
    singleOption && handleTitle && handleTitle(singleOption[0]);
    return otherProps.isMulti ? val : singleOption;
  };

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({
        field: { ref, value, onChange, ...otherRenderProps },
        fieldState: { error },
      }) => (
        <Select
          ref={ref}
          isClearable
          error={Boolean(error)}
          errorText={handleErrorMsg(error, t)}
          {...otherProps}
          {...otherRenderProps}
          value={returnValue(value)}
          onChange={(option) => {
            const newValue = option ? getOptionValue(option) : "";
            onChange(newValue);
            onSubmit?.();
            handleTitle?.(option);
          }}
        />
      )}
      defaultValue={defaultValue}
    />
  );
}
